module.exports = __webpack_public_path__ + "6c902a9de750291664168a568d4bebe2.jpg";